import { unwrapRows } from '@/lib/marketExperience';

const LEVEL_MEANING = {
  confirmed:
    'Evidence this customer is unhappy, or a competitor is inside the same category as the contract comes up.',
  watch: 'Something is on file worth a conversation before renewal.',
  quiet: 'We have looked and found nothing against this account.',
  unknown: 'Nobody has assessed this account yet. This is not the same as low risk.',
};

export const ACCOUNT_RENEWAL_RISK_BADGE = {
  confirmed: { text: 'Confirmed risk', className: 'bg-red-100 text-red-800' },
  watch: { text: 'Watch', className: 'bg-yellow-100 text-yellow-800' },
  quiet: { text: 'No risk found', className: 'bg-green-100 text-green-800' },
  unknown: { text: 'Not assessed', className: 'bg-gray-100 text-gray-800' },
};

function trimId(value) {
  if (value == null || value === '') return '';
  return String(value).trim();
}

function rowIds(row) {
  return [row?.account_id, row?.global_pool_account_id, row?.id]
    .map(trimId)
    .filter(Boolean);
}

/** Pool id first; fall back to account_id. No name matching. */
export function matchRenewalRiskRow(rows, account) {
  if (!account || !Array.isArray(rows) || rows.length === 0) return null;
  const pool = trimId(account.global_pool_account_id);
  if (pool) {
    const hit = rows.find((r) => rowIds(r).includes(pool));
    if (hit) return hit;
  }
  const copy = trimId(account.account_id);
  if (copy) {
    const hit = rows.find((r) => rowIds(r).includes(copy));
    if (hit) return hit;
  }
  return null;
}

export function renewalRiskRowsFromPayload(payload) {
  return unwrapRows(payload);
}

export function renewalRiskBadgeMeta(level) {
  const key = String(level || '').toLowerCase();
  return ACCOUNT_RENEWAL_RISK_BADGE[key] || null;
}

export function renewalRiskTooltipLines(row) {
  if (!row) return [];
  const level = String(row.risk_level || '').toLowerCase();
  const lines = [];
  if (LEVEL_MEANING[level]) lines.push(LEVEL_MEANING[level]);
  const reasonLabel = row.risk_reason_label;
  if (reasonLabel) {
    const extra = Number(row.risk_reason_count);
    const more = extra > 1 ? ` +${extra - 1} more` : '';
    lines.push(`${reasonLabel}${more}`);
  }
  if (row.risk_detail) lines.push(String(row.risk_detail));
  const unknowns = Array.isArray(row.unknowns) ? row.unknowns.filter(Boolean) : [];
  if (unknowns.length) lines.push(`Not yet known: ${unknowns.join(', ')}`);
  return lines;
}

export function renewalRiskSourceUrl(row) {
  const first = Array.isArray(row?.risk_reasons) ? row.risk_reasons[0] : null;
  const url = first?.source_url || first?.url || first?.evidence_url;
  return typeof url === 'string' && url.trim() ? url.trim() : null;
}
